import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, forkJoin } from 'rxjs';

import { BrComService } from '../../service/BrComService';
import { HttpServidor } from '../shared/abstract/http-servidor';

@Injectable()
export class UsuarioProvider extends HttpServidor {

  constructor(http: HttpClient, private brComService: BrComService) {
    super(http);
  }

}



// WEBPACK FOOTER //
// ./src/providers/usuario/usuario.ts